import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/matches',
      name: 'matches',
      component: () => import('@/views/MatchesView.vue'),
    },
    {
      path: '/matches/:match_id',
      name: 'match-detail',
      component: () => import('@/views/MatchDetailView.vue'),
    },
    {
      path: '/live',
      name: 'live-matches',
      component: () => import('@/views/LiveMatchesView.vue'),
    },
    {
      path: '/live/:live_id',
      name: 'live-match-detail',
      component: () => import('@/views/MatchDetailView.vue'),
    },
    {
      path: '/players',
      name: 'players',
      component: () => import('@/views/PlayersView.vue'),
    },
    {
      path: '/players/:steam_id',
      name: 'player-profile',
      component: () => import('@/views/PlayerProfileView.vue'),
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('@/views/ApplyView.vue'),
    },
    {
      path: '/start',
      name: 'start',
      component: () => import('@/views/StartView.vue'),
    },
    {
      path: '/stats/heroes',
      name: 'hero-stats',
      component: () => import('@/views/HeroStatsView.vue'),
    },
    {
      path: '/stats/heroes/:hero',
      name: 'hero-profile',
      component: () => import('@/views/HeroProfileView.vue'),
    },
    {
      path: '/stats/items',
      name: 'item-stats',
      component: () => import('@/views/ItemsView.vue'),
    },
    {
      path: '/patch/classic',
      name: 'patch-classic',
      component: () => import('@/views/PatchClassicView.vue'),
    },
    {
      path: '/patch/actual',
      name: 'patch-actual',
      component: () => import('@/views/PatchActualView.vue'),
    },
  ],
})

export default router
